import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export type EdgeLayout = 'curved' | 'orthogonal';

interface EdgeLayoutState {
  layout: EdgeLayout;
  setLayout: (layout: EdgeLayout) => void;
  toggle: () => void;
}

export const useEdgeLayoutStore = create<EdgeLayoutState>()(
  persist(
    (set) => ({
      layout: 'curved',
      setLayout: (layout) => set({ layout }),
      toggle: () =>
        set((state) => ({
          layout: state.layout === 'curved' ? 'orthogonal' : 'curved',
        })),
    }),
    { name: 'edge-layout' },
  ),
);
